// extracted by mini-css-extract-plugin
module.exports = {"theme":"#f85415"};